import { type CSSProperties, type FC, type ReactElement } from 'react';

import { L10nText } from '@pp/core/src/services/uiTranslations/reactBindings/L10nText';
import { useMedia } from '@pp/core/src/hooks/useMedia';
import { useSettingsSlice } from '@pp/core/src/store/slices/settings/selectors';
import { useIsLargerThanMediumWide, useIsLargerThanWide, useIsPortrait } from '@pp/core/src/styles/hooks/media';
import { useModifiers } from '@pp/core/src/styles/hooks/useModifiers';
import { getStaticResourceUrl } from '@pp/core/src/utils/getStaticBaseUrl';

import styles from './quickGuideContent.module.css';

const PlacingBets: FC = () => {
  let language = useSettingsSlice.currentLanguage().toUpperCase();
  if(language === 'ZH') {
    language = 'CN'
  }
  const isWide = useIsLargerThanWide();
  const isMediumWide = useIsLargerThanMediumWide();
  const mods = useModifiers(styles, 'contentWrapper', {
    isWide,
    isMediumWide,
  });

  let finalLanguage = language;
  const languages = ['AR', 'BG', 'BN', 'CN', 'DA', 'DE', 'EL', 'EN', 'ES', 'FA', 'FI', 'FR', 'HI', 'HR', 'HU', 'HY', 'ID', 'IT', 'JA', 'KA', 'KO', 'LT', 'LV', 'NF', 'NL', 'NO', 'PT', 'RO', 'RU', 'SV', 'TH', 'TR', 'UK', 'VI'];
  if (!languages.includes(language)) {
    finalLanguage = 'EN'
  }

  const url = getStaticResourceUrl(`assets/quickGuide/Slide1/Slide1${finalLanguage}.png`);


  return (
    <div className={`${styles.contentWrapper} ${mods}`}>
      <div className={styles.textSection}>
        <h3>
          <L10nText tk="QG_HIGHFLYER_PLACE_BETS" />
        </h3>
        <p className={styles.text}>
          <L10nText tk="QG_HIGHFLYER_CONFIRM" />
        </p>
      </div>
      <div className={styles.mainSection}>
        <div
          className={`${styles.imageContainer} ${styles.imageContainer1}`}
          style={
            {
              '--imageUrl': `url(${url})`,
            } as CSSProperties
          }
        />
      </div>
    </div>
  );
};

const Multiplier: FC = () => {
  const isWide = useIsLargerThanWide();
  const isMediumWide = useIsLargerThanMediumWide();
  const mods = useModifiers(styles, 'contentWrapper', {
    isWide,
    isMediumWide,
  });

  return (
    <div className={`${styles.contentWrapper} ${mods}`}>
      <div className={styles.textSection}>
        <h3>
          <L10nText tk="QG_HIGHFLYER_WATCH" />
        </h3>
        <p className={styles.text}>
          <L10nText tk="QG_HIGHFLYER_MULTIPLIER" />
        </p>
      </div>
      <div className={styles.mainSection}>
        <div
          className={`${styles.imageContainer} ${styles.imageContainer2}`}
        />
      </div>
    </div>
  );
};

const WinResult: FC = () => {
  let language = useSettingsSlice.currentLanguage().toUpperCase();
  if(language === 'ZH') {
    language = 'CN'
  }
  const isPortrait = useIsPortrait();
  const isLandscape900 = useMedia('(min-width: 900px) and (max-width: 1023px)')
  const isWide = useIsLargerThanWide();
  const isMediumWide = useIsLargerThanMediumWide();
  const mods = useModifiers(styles, 'contentWrapper', {
    isWide,
    isMediumWide,
  });

  let finalLanguage = language

  const languages = ['AR', 'BG', 'BN', 'CN', 'DA', 'DE', 'EL', 'EN', 'ES', 'FA', 'FI', 'FR', 'HI', 'HR', 'HU', 'HY', 'ID', 'IT', 'JA', 'KA', 'KO', 'LT', 'LV', 'NF', 'NL', 'NO', 'PT', 'RO', 'RU', 'SV', 'TH', 'TR', 'UK', 'VI'];

  if (!languages.includes(language)) {
    finalLanguage = 'EN';
  }

  const verticalImage = `Slide3Vertical/Slide3V_${finalLanguage}`;
  const horizontalImage = `Slide3Horizontal/Slide3H_${finalLanguage}`;

  const url = getStaticResourceUrl(`assets/quickGuide/${(isPortrait || isLandscape900) ? verticalImage : horizontalImage}.png`);


  return (
    <div className={`${styles.contentWrapper} ${mods}`}>
      <div className={styles.textSection}>
        <h3>
          <L10nText tk="QG_HIGHFLYER_CLAIM" />
        </h3>
        <p className={styles.text}>
          <L10nText tk="QG_HIGHFLYER_CASHOUT" />
        </p>
      </div>
      <div className={styles.mainSection}>
        <div
          className={`${styles.imageContainer} ${styles.imageContainer3}`}
          style={
            {
              '--imageUrl': `url(${url})`,
            } as CSSProperties
          }
        />
      </div>
    </div>
  );
};

export const quickGuideContent: ReactElement[] = [
  <PlacingBets key="PlacingBets" />,
  <Multiplier key="Multiplier" />,
  <WinResult key="WinResult" />,
];
